import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css'],
})
export class QuestionsComponent {

  @Input() elemento;
  @Input() respuestasGuardas;
  @Input() hojaRes;
  @Input() bndIncompleto;

  preguntas = [''];
  comentarios: Record<number, string> = {};

  @Output() eventContestacion = new EventEmitter();

  ngOnInit(){
    for(const r of this.respuestasGuardas){
      this.preguntas[r.idPregunta] = ''+r.idRespuesta;
      this.comentarios[r.idPregunta] = r.comment || '';
    }  
  }

  hojaRespuestas(preguntaId, respuestaId){
    this.eventContestacion.emit([preguntaId, respuestaId, this.getComment(preguntaId)]);
  }

  getAnswerObject(preguntaId) {
    return this.respuestasGuardas.find(r => r.idPregunta === Number(preguntaId));
  }

  getComment(preguntaId: number) {
    return this.comentarios[preguntaId] ?? this.getAnswerObject(preguntaId)?.comment ?? '';
  }

  onCommentChange(preguntaId: number, event: any) {
    const comment = event.target.value || '';
    this.comentarios[preguntaId] = comment;

    const respuesta = this.getAnswerObject(preguntaId);
    if (respuesta) {
      respuesta.comment = comment;
    }
  }


  sinResponder(pregunta){    
    if(!this.hojaRes.find((resp) => resp['idPregunta'] == pregunta.id) && pregunta.requerida && this.bndIncompleto ){
      return "borderTest2"
    }else{
      return '';
    }
  }

}
